import styled, { css, keyframes } from "styled-components";

const shimmerAnimation = keyframes`
	0% {
		background-position: 200% 0;
	}
	100% {
		background-position: -200% 0;
	}
`;

const shimmer = css`
	background: linear-gradient(90deg, #eef0f3 25%, #f8f9fa 50%, #eef0f3 75%);
	background-size: 200% 100%;
	animation: ${shimmerAnimation} 1.35s ease-in-out infinite;

	@media (prefers-reduced-motion: reduce) {
		animation: none;
	}
`;

export const MetricsContainer = styled.section`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 16px;
	margin-bottom: 24px;
	width: 100%;
	max-width: 1160px;
	margin-left: auto;
	margin-right: auto;

	@media (max-width: 1024px) {
		grid-template-columns: repeat(2, 1fr);
	}

	@media (max-width: 650px) {
		grid-template-columns: 1fr;
	}
`;

export const MetricSkeleton = styled.div`
	height: 103px;
	background: #ffffff;
	border: 1px solid #dcdfe6;
	border-radius: 10px;
	padding: 21px 20px;
	box-shadow: 0 1px 2px rgba(0, 14, 75, 0.02);
	overflow: hidden;
`;

export const SkeletonLabel = styled.div`
	${shimmer}
	width: 48%;
	height: 12px;
	border-radius: 6px;
	margin-bottom: 15px;
`;

export const SkeletonValue = styled.div`
	${shimmer}
	width: 34%;
	height: 29px;
	border-radius: 7px;
`;

export const VisuallyHidden = styled.span`
	position: absolute;
	width: 1px;
	height: 1px;
	padding: 0;
	margin: -1px;
	overflow: hidden;
	clip: rect(0, 0, 0, 0);
	white-space: nowrap;
	border: 0;
`;

export const MetricsError = styled.div`
	grid-column: 1 / -1;
	min-height: 103px;
	border: 1px solid #dcdfe6;
	border-radius: 10px;
	background: #ffffff;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 12px;
	color: #656e7b;
	font-family: "NotoSans-Regular", sans-serif;
	font-size: 13px;

	button {
		border: 0;
		background: transparent;
		color: #009973;
		font: inherit;
		font-weight: 700;
		text-decoration: underline;
		cursor: pointer;
	}
`;
